import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import Box from '@mui/material/Box';

interface PageTitleProps {
  headerId: string;
  headerValue?: any;
}

export const PageHeader = (
  { headerId, headerValue }: PageTitleProps,
) => (
  <Box id="page-title">
    <Typography
      variant="h1"
      fontWeight={600}
      lineHeight={1.1}
      letterSpacing="-.02em"
      color="#16141D"
      sx={theme => ({
        fontFamily: "'Inter Tight', sans-serif",
        fontSize: '30px !important',
        [theme.breakpoints.down('mobile')]: {
          fontSize: '26px !important',
        },
      })}
    >
      <FormattedMessage
        id={headerId}
        values={headerValue}
      />
    </Typography>
  </Box>
);
